import { render, staticRenderFns } from "./tpl-9.vue?vue&type=template&id=4ff13b48&scoped=true&"
import script from "./tpl-9.vue?vue&type=script&lang=js&"
export * from "./tpl-9.vue?vue&type=script&lang=js&"
import style0 from "./tpl-9.vue?vue&type=style&index=0&id=4ff13b48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff13b48",
  null
  
)

export default component.exports